module.exports = __webpack_public_path__ + "img/1534152004.6ef43c65.jpg";